import React from 'react'
import { motion } from 'framer-motion' // Import Motion
import Mimi from '../../assets/ideology.jpg'; 

const ExpertHero = () => {
  // Animation settings for a smooth fade-up effect
  const fadeInVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 2, ease: "easeOut" }
    }
  };

  return (
    <motion.section 
      className='home'
      initial="hidden"
      animate="visible"
      variants={fadeInVariant}
    >
        <div className="hero-grid h">
            <motion.div className="container p-2" variants={fadeInVariant}>
                <h1 className='h1-dark'>EXPERTISE & SKILLS</h1>
                <h2 className='h2-primary'>Technical Engineering & Power Tools</h2>
            </motion.div>

            <motion.div 
                className="container"
                variants={fadeInVariant}
                transition={{ delay: 0.5 }} // Slight delay for the image
            >
                <div className="wrapper">
                    <img src={Mimi} alt="hero" className='hero-img'/>
                </div>
            </motion.div>
        </div>
    </motion.section>
  )
}

export default ExpertHero